import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  it: {
    "nav.dintorni": "Dintorni",
    "nav.gallery": "Gallery",
    "nav.contatti": "Contatti",
    "nav.prenota": "Prenota",
    "nav.tagline": "Hotel & B&B · Angri",

    "landing.eyebrow": "Angri · Provincia di Salerno",
    "landing.hero.line1": "Un rifugio tra la",
    "landing.hero.line2": "Costiera & Napoli.",
    "landing.hero.desc":
      "Hotel Due Pini Conte e G&A Conte B&B: due strutture, una stessa famiglia. Prenota il tuo pernottamento oppure una fascia DayUse per una pausa perfetta.",
    "landing.cta.overnight": "Prenota Pernottamento",
    "landing.cta.dayuse": "Prenota DayUse",

    "landing.intro.eyebrow": "La nostra ospitalità",
    "landing.intro.title":
      "Due strutture, una promessa: farvi sentire a casa.",
    "landing.intro.desc.1": "L'",
    "landing.intro.desc.hotel": "Hotel Due Pini Conte",
    "landing.intro.desc.2":
      " offre camere confortevoli e una suite con vasca idromassaggio, ideale per un soggiorno di relax. Il ",
    "landing.intro.desc.bnb": "G&A Conte B&B",
    "landing.intro.desc.3":
      " vi accoglie in un ambiente familiare con 3 camere curate nei dettagli. Ci troviamo ad Angri, in una posizione strategica per visitare la Costiera Amalfitana, Pompei, Salerno e Napoli.",
    "landing.stat.hotel_rooms": "Camere Hotel",
    "landing.stat.suite": "Suite con vasca",
    "landing.stat.bnb_rooms": "Camere B&B",

    "landing.dintorni.eyebrow": "Da esplorare",
    "landing.dintorni.title":
      "A pochi minuti dai luoghi più iconici della Campania.",
    "dist.costiera.desc": "Positano, Amalfi, Ravello, panorami senza fine.",
    "dist.salerno.desc": "Lungomare, cattedrale e centro storico.",
    "dist.pompei.desc":
      "Il celebre Santuario della Madonna del Rosario e gli scavi archeologici.",
    "dist.napoli.desc": "Il cuore pulsante del Sud, pizza e cultura.",

    "landing.gallery.eyebrow": "Gallery",
    "landing.gallery.title": "L'atmosfera delle nostre stanze.",

    "landing.band.title": "Pronti a fermare il tempo?",
    "landing.band.desc":
      "Scegli la formula più adatta a te: notte intera con colazione o qualche ora di relax nel pomeriggio.",
    "landing.band.overnight": "Pernottamento",
    "landing.band.dayuse": "DayUse",

    "dayuse.eyebrow": "DayUse",
    "dayuse.title": "Qualche ora, tutto il relax.",
    "dayuse.desc.1": "Scegli tu l'ora d'inizio: camere standard ",
    "dayuse.desc.std": "3 ore a €25",
    "dayuse.desc.2": ", Suite con vasca ",
    "dayuse.desc.suite": "2 ore a €50",
    "dayuse.desc.3":
      ". Apertura dalle 08:00, con 30 minuti di pulizia tra un ospite e l'altro.",
    "common.pick_date": "Scegli la data",
    "common.structure": "Struttura",
    "common.all_structures": "Tutte le strutture",
    "dayuse.no_rooms": "Nessuna camera disponibile.",
    "dayuse.select_date": "Seleziona una data",
    "dayuse.start": "Inizio",
    "dayuse.end": "fine",
    "dayuse.book": "Prenota",
    "dayuse.closed": "Chiusa dallo staff",
    "dayuse.busy_overnight": "Occupata (pernottamento)",
    "dayuse.no_slots": "Nessuna fascia disponibile",
    "dayuse.already_booked": "Già prenotato:",
    "dayuse.dialog.title": "Conferma prenotazione DayUse",

    "overnight.eyebrow": "Pernottamenti",
    "overnight.title": "Dormi, sogna, riparti.",
    "overnight.desc":
      "Camera matrimoniale (fino a 2 ospiti) €65/notte, Suite con vasca €110/notte. Per soggiorni con 3 o 4 ospiti supplemento di €15 a persona per ogni ospite oltre i 2.",
    "overnight.dates": "Check-in / Check-out",
    "overnight.pick_dates": "Scegli le date",
    "overnight.guests": "Ospiti",
    "overnight.rooms_for": "Camere per",
    "overnight.guest_1": "ospite",
    "overnight.guests_n": "ospiti",
    "overnight.night_1": "notte",
    "overnight.nights_n": "notti",
    "overnight.no_rooms":
      "Nessuna camera disponibile per questi criteri. Prova a cambiare data o numero ospiti.",
    "overnight.room.matrimoniale": "Camera matrimoniale",
    "overnight.room.suite": "Suite con vasca idromassaggio",
    "overnight.per_night": "notte",
    "overnight.weekend_x": "+weekend ×",
    "overnight.book": "Prenota",
    "overnight.dialog.title": "Conferma pernottamento",
    "overnight.total": "Totale",

    "form.name": "Nome",
    "form.surname": "Cognome",
    "form.phone": "Telefono",
    "form.mobile": "Cellulare",
    "form.mobile_help": "Ti contatteremo su questo numero per confermare",
    "form.email": "Email",
    "form.notes": "Note",
    "form.guests": "Numero ospiti",
    "form.guests_from_to": "Da {min} a {max} ospiti",
    "form.required": "Nome, cognome e telefono sono obbligatori",
    "form.submit": "Conferma prenotazione",

    "footer.tagline":
      "Ospitalità del Sud, a un passo dalla Costiera Amalfitana, Pompei, Salerno e Napoli. Camere confortevoli, DayUse flessibile e la calda accoglienza della famiglia Conte.",
    "footer.contatti": "Contatti",
    "footer.location": "Angri (SA) — Provincia di Salerno",
    "footer.prenota": "Prenota",
    "footer.overnight": "Pernottamenti",
    "footer.dayuse": "DayUse",
    "footer.admin": "Area riservata",
    "footer.dove_siamo": "Dove siamo",

    "success.title": "Prenotazione confermata",
    "success.desc":
      "Conserva questo codice: presentalo in reception per un check-in rapido.",
    "success.reference": "Riferimento",
    "success.print": "Stampa",
    "success.close": "Chiudi",
    "success.scan_qr": "Inquadra il QR in reception per il check-in",

    "checkin.not_found_title": "Non trovata",
    "checkin.not_found_desc":
      "La prenotazione {ref} non esiste o è stata annullata.",
    "checkin.confirmed": "Prenotazione confermata",
    "checkin.room": "Camera",
    "checkin.overnight": "Pernottamento",
    "checkin.dayuse": "DayUse",
    "checkin.guest": "Ospite",
    "checkin.guests": "Ospiti",
    "checkin.total": "Totale",

    "wa.message":
      "Salve, vorrei informazioni per una prenotazione presso Hotel Due Pini Conte.",
  },
  en: {
    "nav.dintorni": "Nearby",
    "nav.gallery": "Gallery",
    "nav.contatti": "Contact",
    "nav.prenota": "Book",
    "nav.tagline": "Hotel & B&B · Angri",

    "landing.eyebrow": "Angri · Salerno Province",
    "landing.hero.line1": "A hideaway between the",
    "landing.hero.line2": "Amalfi Coast & Naples.",
    "landing.hero.desc":
      "Hotel Due Pini Conte and G&A Conte B&B: two properties, one family. Book your stay or a DayUse slot for the perfect break.",
    "landing.cta.overnight": "Book Overnight",
    "landing.cta.dayuse": "Book DayUse",

    "landing.intro.eyebrow": "Our hospitality",
    "landing.intro.title":
      "Two properties, one promise: to make you feel at home.",
    "landing.intro.desc.1": "",
    "landing.intro.desc.hotel": "Hotel Due Pini Conte",
    "landing.intro.desc.2":
      " offers comfortable rooms and a suite with jacuzzi bathtub, ideal for a relaxing stay. ",
    "landing.intro.desc.bnb": "G&A Conte B&B",
    "landing.intro.desc.3":
      " welcomes you in a family atmosphere with 3 carefully curated rooms. We are located in Angri, a strategic base to visit the Amalfi Coast, Pompeii, Salerno and Naples.",
    "landing.stat.hotel_rooms": "Hotel rooms",
    "landing.stat.suite": "Suite with bathtub",
    "landing.stat.bnb_rooms": "B&B rooms",

    "landing.dintorni.eyebrow": "Explore",
    "landing.dintorni.title":
      "Minutes away from Campania's most iconic destinations.",
    "dist.costiera.desc":
      "Positano, Amalfi, Ravello, endless panoramic views.",
    "dist.salerno.desc": "Seafront promenade, cathedral, old town.",
    "dist.pompei.desc":
      "The famous Sanctuary of Our Lady of the Rosary and the archaeological ruins.",
    "dist.napoli.desc": "The beating heart of Southern Italy, pizza and culture.",

    "landing.gallery.eyebrow": "Gallery",
    "landing.gallery.title": "The atmosphere of our rooms.",

    "landing.band.title": "Ready to stop time?",
    "landing.band.desc":
      "Choose what suits you best: a full night with breakfast or a few hours of afternoon relaxation.",
    "landing.band.overnight": "Overnight",
    "landing.band.dayuse": "DayUse",

    "dayuse.eyebrow": "DayUse",
    "dayuse.title": "A few hours, pure relaxation.",
    "dayuse.desc.1": "Pick your own start time: standard rooms ",
    "dayuse.desc.std": "3 hours for €25",
    "dayuse.desc.2": ", Suite with bathtub ",
    "dayuse.desc.suite": "2 hours for €50",
    "dayuse.desc.3":
      ". Open from 08:00, with 30 minutes of cleaning between guests.",
    "common.pick_date": "Pick a date",
    "common.structure": "Property",
    "common.all_structures": "All properties",
    "dayuse.no_rooms": "No rooms available.",
    "dayuse.select_date": "Select a date",
    "dayuse.start": "Start",
    "dayuse.end": "end",
    "dayuse.book": "Book",
    "dayuse.closed": "Closed by staff",
    "dayuse.busy_overnight": "Booked (overnight)",
    "dayuse.no_slots": "No time slot available",
    "dayuse.already_booked": "Already booked:",
    "dayuse.dialog.title": "Confirm DayUse booking",

    "overnight.eyebrow": "Overnight",
    "overnight.title": "Sleep, dream, restart.",
    "overnight.desc":
      "Double room (up to 2 guests) €65/night, Suite with bathtub €110/night. For stays with 3 or 4 guests, a €15/night supplement applies per extra guest over 2.",
    "overnight.dates": "Check-in / Check-out",
    "overnight.pick_dates": "Pick your dates",
    "overnight.guests": "Guests",
    "overnight.rooms_for": "Rooms for",
    "overnight.guest_1": "guest",
    "overnight.guests_n": "guests",
    "overnight.night_1": "night",
    "overnight.nights_n": "nights",
    "overnight.no_rooms":
      "No rooms available for these criteria. Try different dates or guest count.",
    "overnight.room.matrimoniale": "Double room",
    "overnight.room.suite": "Suite with jacuzzi bathtub",
    "overnight.per_night": "night",
    "overnight.weekend_x": "+weekend ×",
    "overnight.book": "Book",
    "overnight.dialog.title": "Confirm overnight stay",
    "overnight.total": "Total",

    "form.name": "First name",
    "form.surname": "Last name",
    "form.phone": "Phone",
    "form.mobile": "Mobile",
    "form.mobile_help": "We'll contact you at this number to confirm",
    "form.email": "Email",
    "form.notes": "Notes",
    "form.guests": "Number of guests",
    "form.guests_from_to": "From {min} to {max} guests",
    "form.required": "First name, last name and phone are required",
    "form.submit": "Confirm booking",

    "footer.tagline":
      "Southern hospitality, a stone's throw from the Amalfi Coast, Pompeii, Salerno and Naples. Comfortable rooms, flexible DayUse and the warm welcome of the Conte family.",
    "footer.contatti": "Contact",
    "footer.location": "Angri (SA) — Salerno Province",
    "footer.prenota": "Book",
    "footer.overnight": "Overnight stays",
    "footer.dayuse": "DayUse",
    "footer.admin": "Staff area",
    "footer.dove_siamo": "Where we are",

    "success.title": "Booking confirmed",
    "success.desc":
      "Keep this code: show it at reception for a quick check-in.",
    "success.reference": "Reference",
    "success.print": "Print",
    "success.close": "Close",
    "success.scan_qr": "Scan the QR at reception for check-in",

    "checkin.not_found_title": "Not found",
    "checkin.not_found_desc":
      "Booking {ref} does not exist or has been cancelled.",
    "checkin.confirmed": "Booking confirmed",
    "checkin.room": "Room",
    "checkin.overnight": "Overnight",
    "checkin.dayuse": "DayUse",
    "checkin.guest": "Guest",
    "checkin.guests": "Guests",
    "checkin.total": "Total",

    "wa.message":
      "Hello, I'd like information for a booking at Hotel Due Pini Conte.",
  },
};

const LanguageContext = createContext({
  lang: "it",
  setLang: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("lang") || "it",
  );

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
    document.documentElement.lang = l;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, params) => {
    let str = DICT[lang]?.[key] ?? DICT.it[key] ?? key;
    if (params) {
      for (const k in params) {
        str = str.replace(`{${k}}`, params[k]);
      }
    }
    return str;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);
